export const COMP_INTEL_FEATURE_COUNT = 4;
export const COMP_INTEL_SEO_FEATURE_COUNT = 9;
export const COMP_INTEL_ADS_FEATURE_COUNT = 11;

export const TRACKING_EVENTS = {
    category: "Package",
    actionShow: "show",
    actionClick: "click",
} as const;

export const TRANSLATION_KEYS = {
    compIntelTitle: "pro.packages.comp_intel.title",
    compIntelItems: "pro.packages.comp_intel",
    compIntelSeoTitleSuffix: "pro.packages.comp_intel_seo.title_suffix",
    compIntelAeoTitleSuffix: "pro.packages.comp_intel_aeo.title_suffix",
    compIntelSeoItems: "pro.packages.comp_intel_seo",
    compIntelAdsTitleSuffix: "pro.packages.comp_intel_ads.title_suffix",
    compIntelAdsItems: "pro.packages.reactivation_v2.ads",
    textPrice: "pro.packages.text_price",
    startsFrom: "pro.packages.starts_from",
    recommendedText: "pro.packages.reactivation_v2.recommended.text",
    buttonText: "pro.packages.button.text",
} as const;
